/** @jsx jsx */
import { jsx, useTheme } from '@emotion/react'
import {
    DataLayerEventName,
    GalleryEvent,
    ImageSourceWithCaptions,
} from '@news-mono/web-common'
import React from 'react'
import { StyledButton } from '../../../buttons/Button/Button.styled'
import {
    StyledThumbnailContainer,
    StyledThumbnailLink,
    StyledThumbnailSection,
} from '../../../content/Gallery/Gallery.styled'
import { ResponsivePicture } from '../../../content/Picture/Picture'
import { ResponsivePictureLayout } from '../../../content/Picture/ResponsivePictureLayouts'
import { metrics } from '../../../__styling/settings/metrics'
import { breakpoint } from '../../../__styling/style-functions'
import { calcRem } from '../../../__styling/style-functions/calc-rem'
import { themedValue } from '../../../__styling/themed-value'

export interface GalleryThumbnailsProps {
    images: ImageSourceWithCaptions[]
    onEvent: (event: GalleryEvent) => void
    scrollTo: (imageIndex: number) => void
    toggleThumbnails: () => void
}

export const GalleryThumbnails: React.FC<GalleryThumbnailsProps> = ({
    images,
    onEvent,
    scrollTo,
    toggleThumbnails,
}) => {
    const theme = useTheme()

    return (
        <StyledThumbnailContainer>
            <StyledThumbnailSection>
                {images.map((img, i) => (
                    <StyledThumbnailLink
                        key={i}
                        onClick={() => {
                            onEvent({
                                type: DataLayerEventName.galleryThumbnailClick,
                                originator: 'Gallery',
                                payload: {
                                    imageIndex: i + 1,
                                },
                            })
                            scrollTo(i)
                        }}
                    >
                        <ResponsivePicture
                            layout={ResponsivePictureLayout.ObjectFitContain}
                            image={img}
                            fixedRatio={img.crops['16:9'] ? '16:9' : 'original'}
                            imageWidths={themedValue(theme, {
                                perthnow: {
                                    mobile: '14vw',
                                    tablet: '16vw',
                                    desktop: '106px',
                                    fallbackWidth: 106,
                                },
                                sevennews: {
                                    mobile: '100vw',
                                    tablet: '50vw',
                                    desktop: '110px',
                                    fallbackWidth: 110,
                                },
                                thewest: {
                                    mobile: '40vw',
                                    tablet: '20vw',
                                    desktop: '110px',
                                    fallbackWidth: 110,
                                },
                            })}
                        />
                    </StyledThumbnailLink>
                ))}
            </StyledThumbnailSection>
            <StyledButton
                onClick={toggleThumbnails}
                css={{
                    margin: `0 auto`,

                    [breakpoint('xs')]: {
                        margin: `0 ${calcRem(
                            metrics.perthnow.margins.lg,
                        )} 0 auto`,
                    },
                }}
            >
                Hide Thumbnails
            </StyledButton>
        </StyledThumbnailContainer>
    )
}
